/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserSearchLimit} from '../models/UserSearchLimit';
import type {UserTotalLimit} from '../models/UserTotalLimit';
import type {UsersTotalLimitRequest} from '../models/UsersTotalLimitRequest';

export interface GetUserLimit$Request {
    userId: number;
    limitTotalColumn: string;
}

export interface GetUserLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserLimitRequest = createAction<PayloadData<void, GetUserLimit$Request>>('USER_SEARCH_LIMIT__GET_USER_LIMIT__REQUEST');
export const getUserLimitSuccess = createAction<PayloadData<UserTotalLimit, GetUserLimit$Request>>('USER_SEARCH_LIMIT__GET_USER_LIMIT__SUCCESS');
export const getUserLimitFailure = createAction<PayloadData<Error, GetUserLimit$Request, true>>('USER_SEARCH_LIMIT__GET_USER_LIMIT__FAILURE');

export const getUserLimitActions = [
    getUserLimitRequest,
    getUserLimitSuccess,
    getUserLimitFailure
] as const;

/**
 * @param {number} meta.userId The user id
 * @param {string} meta.limitTotalColumn The type of limit column
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserLimit = (meta: GetUserLimit$Request, config?: GetUserLimit$Config) => {
    return {
        CALL_API: {
            types: getUserLimitActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/limits/${meta.limitTotalColumn}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsersTotalLimits$Request {
    usersTotalLimitRequest: UsersTotalLimitRequest;
}

export interface GetUsersTotalLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersTotalLimitsRequest = createAction<PayloadData<void, GetUsersTotalLimits$Request>>('USER_SEARCH_LIMIT__GET_USERS_TOTAL_LIMITS__REQUEST');
export const getUsersTotalLimitsSuccess = createAction<PayloadData<{ [key: string]: Array<UserSearchLimit>; }, GetUsersTotalLimits$Request>>('USER_SEARCH_LIMIT__GET_USERS_TOTAL_LIMITS__SUCCESS');
export const getUsersTotalLimitsFailure = createAction<PayloadData<Error, GetUsersTotalLimits$Request, true>>('USER_SEARCH_LIMIT__GET_USERS_TOTAL_LIMITS__FAILURE');

export const getUsersTotalLimitsActions = [
    getUsersTotalLimitsRequest,
    getUsersTotalLimitsSuccess,
    getUsersTotalLimitsFailure
] as const;

/**
 * @param {UsersTotalLimitRequest} meta.usersTotalLimitRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersTotalLimits = (meta: GetUsersTotalLimits$Request, config?: GetUsersTotalLimits$Config) => {
    return {
        CALL_API: {
            types: getUsersTotalLimitsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/search/total-limits`,
            TRANSPORT_REQUEST_BODY: meta.usersTotalLimitRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

